export const columnGidLayout = (column) => {
  // here 12 represents number of grids
  return column > 0 ? 12 / column : 0;
};
